export default "__VITE_ASSET__CbN2hbsi__"